import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import SharePhotoToSocialMedia from "../SharePhotoToSocialMedia";

import Facebook from "../icons/Facebook";
import Twitter from "../icons/Twitter";

import { Flexbox } from "../shared";
import { colors } from "../shared/colors";
import { SocialsWrapper, TextWrapper, Wrapper } from "./styles";

const UnwrappedMessageBanner = ({
    className,
    showSocialLinks,
    accentColor,
    icon,
    iconTitle,
    photo,
    children
}) => {
    const Icon = icon;

    return (
        <Wrapper className={className} accentColor={accentColor}>
            <Flexbox alignItems="center" justifyContent="space-between">
                <Flexbox alignItems="center">
                    {/* 'size' and 'fillColor' props are used
                    to style "styled-svg" components only */}
                    <Icon
                        title={iconTitle}
                        size={{ width: 21, height: 21 }}
                        fillColor={accentColor}
                    />
                    <TextWrapper>{children}</TextWrapper>
                </Flexbox>
                {showSocialLinks && (
                    <SocialsWrapper
                        flexWrap="nowrap"
                        alignItems="center"
                        justifyContent="flex-end"
                    >
                        <SharePhotoToSocialMedia
                            platform="Facebook"
                            photo={photo}
                        >
                            <Facebook
                                title="Facebook logo"
                                fillColor={colors.emptySearchBG}
                                size={{ width: 24, height: 24 }}
                            />
                        </SharePhotoToSocialMedia>
                        <SharePhotoToSocialMedia
                            platform="Twitter"
                            photo={photo}
                        >
                            <Twitter
                                title="Twitter logo"
                                fillColor={colors.emptySearchBG}
                                size={{ width: 23, height: 23 }}
                            />
                        </SharePhotoToSocialMedia>
                    </SocialsWrapper>
                )}
            </Flexbox>
        </Wrapper>
    );
};

UnwrappedMessageBanner.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    showSocialLinks: PropTypes.bool,
    accentColor: PropTypes.string,
    photo: PropTypes.object,
    iconTitle: PropTypes.string,
    // pass React component, like an SVG styled-component
    icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
};

const MessageBanner = styled(UnwrappedMessageBanner)``;

export default MessageBanner;
